import { render, staticRenderFns } from "./NewsItemJLP.vue?vue&type=template&id=b1fbd25a&scoped=true&"
import script from "./NewsItemJLP.vue?vue&type=script&lang=ts&"
export * from "./NewsItemJLP.vue?vue&type=script&lang=ts&"
import style0 from "./NewsItemJLP.vue?vue&type=style&index=0&id=b1fbd25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fbd25a",
  null
  
)

export default component.exports